import { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MuiButtonPrimary, MuiButtonSecondary } from "../../../../components";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS, PAGE_URLS } from "../../../../helpers/constants";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { ViewProgramTemplateFooterWrapper } from "./ViewProgramTemplateFooter.style";

interface ViewProgramTemplateFooterProps {
  pageId: string;
  handleNavigateBack: () => void;
  handleEdit?: () => void;
  isVersionLatest?: boolean;
}

export const ViewProgramTemplateFooter: FC<ViewProgramTemplateFooterProps> = ({
  pageId,
  handleNavigateBack,
  handleEdit,
  isVersionLatest,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { commonLabels } = useSiteCore();

  const onCloseButton = () => {
    handleNavigateBack();
  };

  const onEditButton = () => {
    navigate(`${PAGE_URLS.EDIT_PROGRAM_TEMPLATE}/${id}`);
  };

  return (
    <ViewProgramTemplateFooterWrapper>
      <MuiButtonSecondary id={`${pageId}-close`} onClick={onCloseButton}>
        {commonLabels.close}
      </MuiButtonSecondary>
      <PermissionWrapper permission={MODULE_PERMISSIONS.PROGRAM_TEMPLATE_EDIT}>
        <MuiButtonPrimary
          onClick={handleEdit ?? onEditButton}
          id={`${pageId}-edit`}
          disabled={!isVersionLatest}
        >
          {commonLabels.edit}
        </MuiButtonPrimary>
      </PermissionWrapper>
    </ViewProgramTemplateFooterWrapper>
  );
};
